import { useEffect, useRef, useState } from "react";
import { AnonimizeStateCombined, AnonimizeStateState, AnonimizeVisualState, getAnonimizedStateCombined } from "../../types/AnonimizeState";
import { UserFile } from "../../types/UserFile";
import { Bicon, Button } from "../../util/BootstrapIcons";
import BootstrapModal from "../../util/BootstrapModal";
import { EntitiesStyle } from "../../util/entitiesStyle";
import { ExitButton, ForceExitButton } from "../../util/exitButton";
import { InfoModalContent } from "../../util/infoModalContent";
import { SuggestButton } from "../../util/runRemoteNlp";
import { SavedBadge } from "../../util/savedBadge";
import { useSave } from "../../util/uses";
import AnonimizeContent from "./Content";
import { EntityTable } from "./EntityTable";
import { HistoryCommands } from "./HistoryCommands";
import { ImageEditorModal } from "./ImageEditorModal";
import { SearchModalContent } from "./SearchModalContent";
import { TypesModalContent } from "./TypesModalContent";
import { ToolsButton, ToolsModalBody } from "./Tools";
import { ExportButton } from "./ExportButton";
import { loadAnonimizeProfiles, getAnonimizeProfiles, AnonimizeProfile } from "../../util/AnonimizeProfiles";

interface AnonimizeProps {
    file: UserFile
    setUserFile: (file: UserFile | undefined) => void
}

const Sep = () => <small className="text-white text-nowrap p-1 m-1 flex-grow-1 text-center"><Bicon n="dot" /></small>;

export default function Anonimize({ file, ...props }: AnonimizeProps) {
    // States
    const [anonimizeState, setAnonimizeSate] = useState<AnonimizeStateCombined>(getAnonimizedStateCombined(AnonimizeVisualState.ALL_TYPES));
    const saved = useSave(file);
    const [requesting, setRequesting] = useState<boolean>(false);

    const anonimizedHTML = useRef<string>("");
    const [profiles, setProfiles] = useState<{ name: string; label: string }[]>([]);
  
    //  Variavel para tabela do dados anonizados
    const [showEntityTable, setShowEntityTable] = useState(false);
    const [showSentencePanel, setShowSentencePanel] = useState(false);
    const [controlsEnabled, setControlsEnabled] = useState(false);
    
    useEffect(() => {
      loadAnonimizeProfiles()
        .then(() => {
          const perfis = getAnonimizeProfiles();
          setProfiles(perfis);
        })
        .catch();
    }, []);

    useEffect(() => {
        const onExit = (evt: BeforeUnloadEvent) => {
            if (!saved) {
                evt.preventDefault();
                evt.returnValue = "Trabalho em progresso não guardado automaticamente. Confirma que pertende sair?"
            }
            if (requesting) {
                evt.preventDefault();
                evt.returnValue = "A anonimização automática será cancelada. Confirma que pertende sair?"
            }
        }
        window.addEventListener("beforeunload", onExit)
        return () => {
            window.removeEventListener("beforeunload", onExit)
        }
    }, [requesting, saved])

    const handleSetRequesting = (value: boolean) => {
      setRequesting(value);
      if (value) {
        setControlsEnabled(true);
      }
    };

    return <>
        <div className="row container-fluid bg-dark m-0 p-0">
            <EntitiesStyle file={file} />
            <div className="col-12">
                <div className="position-sticky top-0 bg-white p-0 m-0 d-flex" style={{ borderBottom: "5px solid #161616", zIndex: 1 }}>
                    {requesting ? <ForceExitButton setUserFile={props.setUserFile} /> : <ExitButton file={file} setUserFile={props.setUserFile} />}
                    <SavedBadge file={file} />
                    {/*<ToolsButton /> */}
                    {/*<Button title="Gerir tipos" i="file-earmark-font" text="Tipos" className="btn btn-sm text-body  alert alert-primary m-1 p-1" data-bs-toggle="modal" data-bs-target="#modal-types" />*/}
                    {/*<select title="Escolher modo" className="text-body btn m-1 p-1 text-start alert alert-primary" onChange={(ev) => setAnonimizeSate(getAnonimizedStateCombined(ev.target.value as AnonimizeVisualState))} defaultValue={AnonimizeVisualState.TYPES}>
                        <option value={AnonimizeVisualState.ORIGINAL}>{AnonimizeVisualState.ORIGINAL}</option>
                        <option value={AnonimizeVisualState.REPLACE}>{AnonimizeVisualState.REPLACE}</option>
                        <option value={AnonimizeVisualState.TYPES}>{AnonimizeVisualState.TYPES}</option>
                        <option value={AnonimizeVisualState.ANONIMIZED}>{AnonimizeVisualState.ANONIMIZED}</option>
                    </select> */}
                      <Sep />

                      <SuggestButton file={file} state={anonimizeState.state} setRequesting={handleSetRequesting} requesting={requesting} />
                      {controlsEnabled && (
                          <>
                                <Button
                                    title="Gerir os dados protegendo informações pessoais e sensíveis"
                                    i="shield-lock"
                                    text="Opções de Anonimização"
                                    className="me-1"
                                    onClick={() => setShowEntityTable(true)}
                                 />

                                <Button
                                    i="eye-slash"
                                    text="Mostrar Conteúdo Anonimizado"
                                    className="me-1"
                                    onClick={() => setShowSentencePanel(true)}
                                />


                    <ExportButton file={file} />
                          </>
                      )}

                    <Sep />
                    {/*<Button title="Pesquisar" i="search" text="Pesquisar" className="btn btn-sm text-body  alert alert-primary m-1 p-1" data-bs-toggle="modal" data-bs-target="#modal-search" /> */}
                    {/*<HistoryCommands pool={file.pool} /> */}
                    <a className="red-link m-1 p-1 btn" href="https://docs.google.com/document/d/e/2PACX-1vTaR6kTasw0iGYSSMbJpq2wMgrBN5K37jg5ab_qMih_VpXRO5ZAAeeeDiRYzvyrD_VDxBM2ccW-VuBQ/pub" target="_blank" title="Abrir ajuda" rel="noreferrer"><Bicon n="question-circle" /></a>
                </div>

                {/* PAGINAÇÃO  */}
                {/*<div className="bg-white p-4">
                    {requesting && anonimizeState.state === AnonimizeStateState.TAGGED ?
                        <div className="alert alert-info">A processar o documento, esta operação poderá demorar.</div>
                        :
                        <AnonimizeContent accessHtml={(html) => anonimizedHTML.current = html} showTypes={anonimizeState.showTypes} file={file} anonimizeState={anonimizeState.state} />
                    }
                </div> */}
                <div className="row m-0 p-0 bg-white">
                  {/* Coluna esquerda - SENTENÇA ORIGINAL */}
                  <div className="col-6 p-3">
                    <div
                      className="bg-white border rounded shadow-sm p-3"
                      style={{
                        maxHeight: "80vh",
                        overflowY: "auto",
                      }}
                    >
                      <h5 className="text-center fw-bold"> SENTENÇA ORIGINAL</h5>
                      <AnonimizeContent
                        accessHtml={(html) => (anonimizedHTML.current = html)}
                        showTypes={false}
                        file={file}
                        anonimizeState={AnonimizeStateState.ORIGINAL}
                      />
                    </div>
                  </div>

                  {/* Coluna direita - SENTENÇA ANONIMIZADA */}
                  {controlsEnabled && (
                  <div className="col-6 p-3">
                    <div
                      className="bg-white border rounded shadow-sm p-3"
                      style={{
                        maxHeight: "80vh",
                        overflowY: "auto",
                      }}
                    >
                      <h5 className="text-center fw-bold">SENTENÇA - SUBSTITUIÇÕES</h5>
                      {requesting && anonimizeState.state === AnonimizeStateState.TAGGED ? (
                        <div className="alert alert-info">
                          A processar o documento, esta operação poderá demorar.
                        </div>
                      ) : (
                        <AnonimizeContent
                          accessHtml={(html) => (anonimizedHTML.current = html)}
                          showTypes={anonimizeState.showTypes}
                          file={file}
                          anonimizeState={anonimizeState.state}
                        />
                      )}
                    </div>
                  </div>
                  )}
                </div>

            </div>

            {/* PÁGINA DOS DADOS DOS DO ANONIMIZADOR */}
           {/* <div className="col-4">
                <div className="m-0 position-sticky top-0">
                    <EntityTable file={file} />
                </div>
            </div> */}

            {/**
            {showEntityTable && (
              <div className="col-6 bg-white border-start">
                <div className="m-0 position-sticky top-0 p-2">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <strong>Dados do Anonimizador</strong>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => setShowEntityTable(false)}
                    >
                      Fechar
                    </button>
                  </div>
                  <EntityTable file={file} />
                </div>
              </div>
            )}   */}
            {showEntityTable && (
              <div
                className="position-absolute bg-white border rounded shadow p-3"
                style={{
                  top: "100px", // ajuste conforme necessário para evitar sobreposição do topo
                  left: "30px", // ou use calc para alinhar com a coluna esquerda
                  width: "45%", // igual ou menor que .col-6
                  maxHeight: "80vh",
                  zIndex: 1050, // acima do conteúdo principal
                  overflowY: "auto",
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h5 className="text-center m-0">Opções de Anonimização</h5>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => setShowEntityTable(false)}
                  >
                    Fechar
                  </button>
                </div>
                <EntityTable file={file} />
              </div>
            )}

            {showSentencePanel && (
              <div
                className="position-absolute bg-white border rounded shadow p-3"
                style={{
                  top: "100px",
                  right: "30px",          // painel do lado direito
                  width: "45%",
                  maxHeight: "80vh",
                  zIndex: 1050,
                  overflowY: "auto",
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h5 className="text-center m-0">SENTENÇA ANONIMIZADA</h5>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => setShowSentencePanel(false)}
                  >
                    Fechar
                  </button>
                </div>

                <AnonimizeContent
                  accessHtml={(html) => (anonimizedHTML.current = html)}
                  showTypes={anonimizeState.showTypes}
                  file={file}
                  anonimizeState={AnonimizeStateState.ANONIMIZED}
                />
            </div>
            )}

        </div>
        <BootstrapModal id="modal-types">
            <TypesModalContent file={file} />
        </BootstrapModal>
        <ImageEditorModal file={file} />
        <BootstrapModal id="modal-info">
            <InfoModalContent file={file} />
        </BootstrapModal>
        <BootstrapModal id="modal-search">
            <SearchModalContent file={file} />
        </BootstrapModal>
        <BootstrapModal id="modal-tools">
            <ToolsModalBody file={file} />
        </BootstrapModal>
    </>
}
